module.exports = __webpack_public_path__ + "static/amare_img_19_v-b6223e190bffeb65acb4236af1fbbebf.jpg";